<template>
  <VuePortal target="[data-popups]" append>
    <TransitionFade body-scroll-lock>
      <ModalWindow
        v-if="visible"
        :title="title"
        :with-embed="withEmbed"
        :has-header="hasHeader"
        popup
        @close="$emit('close')"
        v-on="backListener"
      >
        <slot />
        
        <template #footer>
          <slot name="footer" />
        </template>
      </ModalWindow>
    </TransitionFade>
  </VuePortal>
</template>

<script>

  import { bem } from 'src/utils/bem.js';

  import ModalWindow from 'src/components/overlays/ModalWindow/ModalWindow.vue';
  import TransitionFade from 'src/components/transitions/TransitionFade/TransitionFade.vue';
  import VuePortal from 'src/components/VuePortal/VuePortal.vue';

  export default {
    name: 'BasicPopup',
    components: { ModalWindow, TransitionFade, VuePortal },
    props: {
      title: {
        type: String,
        default: ''
      },
      visible: Boolean,
      withEmbed: Boolean,
      hasHeader: {
        type: Boolean,
        default: true
      },
    },
    emits: ['close', 'back'],
    methods: {
      bem
    },
    computed: {
      backListener() {
        return this.$listeners.back ? { back: this.$listeners.back } : {};
      }
    }
  };
</script>
